import { message } from 'antd';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';
import uistate from '../uistate';

export function loadChangelog(idProcessingActivity) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.CLEAR_CHANGELOG,
        });
        
        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/changelog/${idProcessingActivity}`);
        dispatch({
            type: t.LOAD_CHANGELOG,
            payload: resp.data
        });
    };
}






